export enum ProductionUnit {
	mm = 'mm',
	cm = 'cm',
	ln = 'ln',
}

export enum ThProductionUnit {
	mm = 'มม',
	cm = 'ซม',
	ln = 'นิ้ว',
}
